<template>
  <div class="_LoginBox">
		<div :class="'_login ' + [tabActive == '2' ? '_login2' : '']">
			<div class="Title">
				<!-- <img @click.stop="guaB()" src="../assets/GuaB.png" alt=""> -->
				<i class="el-icon-close" @click.stop="guaB()" />
			</div>
			<div class="LogoBox">
				<img src="../assets/logo_all.png" alt="">
			</div>
			<div class="FromBox">
				<div class="_tab">
					<p 
						v-for="(item, index) in tabList" 
						:key="index"
						:class="[tabActive == item._active ? '_p_active' : '']"
						@click.stop="tabActiveP(item._active)"
					>{{item.name}}</p>
				</div>
				<div class="_tabCont _tabContActive1" v-if="tabActive == '1'">
					<el-input
						class="_elInput"
						placeholder="请输入用户名/手机号"
						prefix-icon="el-icon-mobile-phone"
						v-model="userPhone">
					</el-input>
					<el-input
						v-if="tabCode"
						class="_elInput"
						show-password
						placeholder="请输入登录密码"
						prefix-icon="el-icon-lock"
						v-model="userPass">
					</el-input>
					<!-- <div class="_elBox" v-if="!tabCode">
						<el-input
							class="_elInput"
							placeholder="请输入验证码"
							prefix-icon="el-icon-unlock"
							v-model="userCode">
						</el-input>
						<p class="_code" @click.stop="show ? getCode() : ''">{{show ? '获取验证码' : count}}</p>
					</div> -->
					<p class="_TabBot">
						<span></span>
						<span class="_forget" @click.stop="forget()">忘记密码?</span>
					</p>
					<p class="_loginBut" @click.stop="login()">立即登录</p>
					<!-- <p class="_tabLogin" @click.stop="tab_Code()">{{tabCode ? '切换验证码登录' : '切换密码登录'}}</p> -->
				</div>
				<div class="_tabCont _tabContActive2 " v-if="tabActive == '2'">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
						<el-form-item label="" prop="name">
							<el-input prefix-icon="el-icon-user" placeholder="请输入用户名/手机号" v-model="ruleForm.name"></el-input>
						</el-form-item>
						<el-form-item label="" prop="phone">
							<el-input prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号" v-model="ruleForm.phone"></el-input>
						</el-form-item>
						<el-form-item label="" prop="password" class="_pwdBox">
							<el-input show-password prefix-icon="el-icon-lock" placeholder="请输入密码" v-model="ruleForm.password">
								<template slot="suffix">
									<el-tooltip effect="dark" placement="left">
										<div slot="content">
											密码规则
											<p>格式：必须包含字母(大小写均可)和数字,特殊字符可选</p>
											<p>长度：6-18位</p>
											<p>特殊字符：! @ # $ % ^ & * ( ) _ + - = [ ] { } ; : ' " \ | , . < > / ?</p>
										</div>
										<i class="el-input__icon el-icon-question pwd-question" />
									</el-tooltip>
								</template>
							</el-input>
						</el-form-item>
						<el-form-item class="_imgCodeBox" label="" prop="Captcha">
							<el-input prefix-icon="el-icon-picture-outline" placeholder="请输入图片验证码" v-model="ruleForm.Captcha"></el-input>
							<div class="_captchaImg" @click.stop="refreshCaptcha()">
								<img :src="captchaUrl" alt="验证码" />
							</div>
						</el-form-item>
						<el-form-item class="_codeBox" label="" prop="code">
							<el-input prefix-icon="el-icon-chat-dot-square" placeholder="请输入短信验证码" v-model="ruleForm.code"></el-input>
							<p @click.stop="show ? getCode() : ''" >{{show ? '获取验证码' : count}}</p>
						</el-form-item>
						<!-- 推荐码已隐藏 -->
						<el-form-item label="" class="_types">
							<el-checkbox-group v-model="checked">
								<el-checkbox label="" name="type">
									<template>
										<div class="_agreeText">
											<span>我已阅读并接受</span>
											<span @click.stop="jumpService()">《步峰代理用户服务协议》</span>
											<span>和</span>
											<span @click.stop="jumpPolicy()">《步峰代理隐私保护政策》</span>
										</div>
									</template>
								</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item class="_submitBox">
							<!-- <p ></p> -->
							<el-button type="primary" @click="submitForm('ruleForm')">注册</el-button>
							<!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { request } from "../css/request.js";
import { resetLoginFlag } from "../router/index.js";
import { Apis } from "../css/Api.js";
import { appendChannelData, clearChannelData } from "../utils/channelData.js";
export default {
  name: 'Login',
  props: {

  },
  data(){
    return{
			tabList:[
				{name:'登录',_active:'1'},
				{name:'注册',_active:'2'},
			],
			tabActive:'1',
			tabCode:true,
			userPhone:'',
			userPass:'',
			userCode:'',
			ruleForm:{
				name:'',
				phone:'',
				password:'',
				code:'',
				Captcha:'',
				recommend:'',
			},
			rules:{
				name:[{ required: true, message: '请输入用户名/手机号', trigger: 'change' }],
				phone:[{ required: true, message: '请输入手机号', trigger: 'change' }],
				password:[{ required: true, message: '请输入密码', trigger: 'change' }],
				code:[{ required: true, message: '请输入短信验证码', trigger: 'change' }],
				Captcha:[{ required: true, message: '请输入图片验证码',trigger: 'change' }],
				// recommend:[{ required: true, message: '请输入推荐码()', trigger: 'change' }],
			},
			checked:false,
			show:true,
			timer: null,
			count:'',
			captchaUrl: '',
			captchaKey: '',
    }
	},
	computed:{
    RegisterType(){
      return this.$store.state.registerType
    }
	},
	watch:{
		'RegisterType':{
			handler(value){
        if(value){
					this.tabActive = value
				} else {
					// null 或 undefined 时显示登录
					this.tabActive = '1'
				}
      },
      immediate: true,
			deep: true 
		}
	},
  created(){
		this.refreshCaptcha()
  },
  methods:{
		forget(){
			this.$alert('请联系客服找回', '提示', {
				confirmButtonText: '确定',
				callback: action => {
					
				}
			});
		},
		handleClick(tab, event){
		},
		tabActiveP(indexs){
			this.tabActive = indexs
		},
		tab_Code(){
			this.tabCode = !this.tabCode
		},
		jumpService(){
			// 新窗口打开服务条款页
			window.open(window.location.origin + '/service', '_blank')
		},
		jumpPolicy(){
			// 新窗口打开隐私政策页
			window.open(window.location.origin + '/policy', '_blank')
		},
		login(){
			let data = {}
			let url = null
			let _method = null
			if(!this.userPhone){
				this.$message.error('请输入用户名/手机号');
				return;
			}else{
				if(!this.tabCode){
					url = Apis.signinCode
					_method = 'post'
					data.phone = this.userPhone
					if(!this.userCode){
						this.$message.error('请输入验证码');
						return;
					}else{
						data.smsCode = this.userCode
					}
				}else{
					url = Apis.login
					_method = 'get'
					data.username = this.userPhone
					if(!this.userPass){
						this.$message.error('请输入密码');
						return;
					}else{
						data.password = this.userPass
					}
				}
			}
			request({
				method: _method, 
				url: url,
				params:data,
				_type:1,
			}).then(res => {
				if(res.code == 0){
					this.$message({
						message: '登录成功',
						showClose: true,
						duration:1500,
						type: 'success'
						
					});
					// 重置登录弹窗标志
					resetLoginFlag()
					// this.CodeTime()
					localStorage.setItem('name', res.data.name);
					localStorage.setItem('access_token', res.data.access_token);
					localStorage.setItem('id', res.data.id);
					localStorage.setItem('username', this.userPhone);
					localStorage.setItem('userpass', this.userPass);
					this.$store.commit("setaccess_token", res.data.access_token);
					// 关闭登录框并刷新页面
					this.guaB()
					setTimeout(() => {
						window.location.reload()
					}, 500)
				}else{
					this.$message.error(res.msg);
				}
			});
			
		},
		getCode(){

			// 先验证图片验证码
			if(!this.ruleForm.Captcha){
				this.$message({
					message: '请输入图片验证码',
					showClose: true,
					duration:1500,
          type: 'warning'
				});
				return;
			}
			if(!this.ruleForm.phone){
				this.$message({
					message: '请输入手机号',
					showClose: true,
					duration:1500,
          type: 'warning'
				});
				return;
			}
			let data = {
				mobile:this.ruleForm.phone,
				captcha_key: this.captchaKey,
				captcha: this.ruleForm.Captcha
			}
			request({
				method: "post", 
				url: Apis.getSmsCode,
				params:data,
				_type:1,
			}).then(res => {
				if(res.code == 0){
					this.$message({
						message: res.msg,
						showClose: true,
						duration:1500,
						type: 'success'
					});
					this.CodeTime()
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		CodeTime(){
			const TIME_COUNT = 60;
			if (!this.timer) {
				this.count = TIME_COUNT;
				this.show = false;
				this.timer = setInterval(() => {
				if (this.count > 0 && this.count <= TIME_COUNT) {
					this.count--;
					} else {
					this.show = true;
					clearInterval(this.timer);
					this.timer = null; 
					}
				}, 1000)
			}
		},
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
				if(!this.checked){
					this.$message({
						message: '请阅读并同意用户协议',
						showClose: true,
						duration:1500,
						type: 'warning'
					});
					return;
				}
				if (valid) {
					if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,18}$/.test(this.ruleForm.password)) {
							this.$message({
							message: '您的密码复杂度太低，请修改密码',
							showClose: true,
							duration:1500,
							type: 'warning'
						});
						return;
					}
					this.register()
				} else {
					return false;
				}
			});
		},
		register(){
			const data = {
				name:this.ruleForm.name,
				phone:this.ruleForm.phone,
				password:this.ruleForm.password,
				smsCode:this.ruleForm.code,
				captcha:this.ruleForm.Captcha
			}
			if(this.ruleForm.recommend) data.invitation = this.ruleForm.recommend
			appendChannelData(data)
			request({
				method: "post", 
				url: Apis.register,
				params:data,
				_type:1,
			}).then(res => {
				// 注册成功后刷新验证码
				this.refreshCaptcha();
				// 清空验证码输入框
				this.ruleForm.Captcha = '';
				this.ruleForm.code = '';
				
				if(res.code == 0){
					this.$message({
						message: res.msg || '注册成功',
						showClose: true,
						duration:2000,
						type: 'success'
					});
					// 仅清渠道快照与 URL 的 utm_s，保留 bdData 供充值/套餐
					clearChannelData()
					// 自动登录
					this.autoLogin()
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		autoLogin(){
			// 使用注册的账号密码自动登录
			let loginData = {
				username: this.ruleForm.name,
				password: this.ruleForm.password
			}
			request({
				method: "get",
				url: Apis.login,
				params: loginData,
				_type: 1,
			}).then(res => {
				if(res.code == 0){
					// 重置登录弹窗标志
					resetLoginFlag()
					// this.CodeTime()
					localStorage.setItem('name', res.data.name);
					localStorage.setItem('access_token', res.data.access_token);
					localStorage.setItem('id', res.data.id);
					localStorage.setItem('username', this.userPhone);
					localStorage.setItem('userpass', this.userPass);
					this.$store.commit("setaccess_token", res.data.access_token);
					// 关闭登录框并刷新页面
					this.guaB()
					setTimeout(() => {
						window.location.reload()
					}, 500)
					
				}
			}).catch(err => {
				console.error('自动登录失败', err)
			})
		},
		guaB(){
			this.$store.commit("setLoginType", false);
		},
		// 获取后端验证码图片
		refreshCaptcha(){
			request({
				method: "get",
				url: Apis.imgCaptcha,
				_type: 1,
			}).then(res => {
				if(res.code == 0){
					// 后端返回 base64 图片数据和 key
					this.captchaUrl = res.data.img
					this.captchaKey = res.data.key
				}else{
					this.$message.error(res.msg || '获取验证码失败')
				}
			}).catch(err => {
				console.error('获取验证码失败:', err)
				this.$message.error('获取验证码失败，请重试')
			})
		},
  }
}
</script>

<style scoped lang="less">
._LoginBox{
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, .7);
	position: fixed;
	left: 0;
	top: 0;
	z-index: 99;
	// display: ;
	._login{
		width: 380px;
		height: 400px;
		background: #fff;
		position: relative;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		padding: 15px;
		.Title{
			width: 100%;
			position: relative;
			i{
				display: inline-block;
				width: 16px;
				height: 16px;
				position: absolute;
				right: 0px;
				font-size: 20px;
				cursor: pointer;
			}
		}
		.LogoBox{
			width: 100%;
			height: 45px;
			img{
				margin: 0 auto;
			}
		}
		.FromBox{
			width: 100%;
			._tab{
				width: 100%;
				display: flex;
				justify-content: center;
				margin-top: 20px;
				p{
					
					color: #999999;
					font-size: 20px;
					font-weight: bold;
					cursor:pointer;
					position: relative;
					float: left;
				}
				p:nth-child(2){
					margin-left: 80px;
				}
				._p_active{
					color: #51B3FF;
				}
				._p_active::after{
					content: '';
					display: inline-block;
					width: 80px;
					height: 2px;
					background: #51B3FF;
					position: absolute;
					bottom: -10px;
					left: 50%;
					transform: translateX(-50%);
					transition: 2s;
				}
			}
			._tabCont{
				width: 100%;
				padding: 0 30px;
				._elBox{
					width: 100%;
					display: flex;
					align-items: center;
					._code{
						width: 140px;
						display: block;
						height: 40px;
						margin-top: 30px;
						line-height: 40px;
						color: #fff;
						background: #51B3FF;
						border-radius: 0 4px 4px 0;
						font-size: 13px;
					}
				}
				._elInput{
					margin-top: 30px;
				}
				._elInput:nth-child(1){
					margin-top: 30px;
				}
				._TabBot{
					width: 100%;
					display: flex;
					justify-content: space-between;
					font-size: 12px;
					margin-top: 15px;
					color: #D2D2D2;
					._forget{
						cursor:pointer;
					}
				}
				._loginBut{
					width: 100%;
					height: 40px;
					background: #51B3FF;
					border-radius: 6px;
					color: #fff;
					font-size: 14px;
					font-weight: bold;
					line-height: 40px;
					margin-top: 30px;
					cursor: pointer;
				}
				._tabLogin{
					color: #51B3FF;
					font-size: 12px;
					margin-top: 10px;
					// width: 100;
				}
			}
			._tabContActive1{
				margin-top: 20px;
				// height
			}
			._tabContActive2{
				// height: ;
			}
		}
	}
	._login2{
		height: 540px;
		._tabContActive2{
			margin-top: 30px;
			._codeBox{
				display: flex;
				p{
					width: 140px;
					display: inline-block;
					height: 40px;
					border-radius: 0 4px 4px 0;
					color: #fff;
					background: #51B3FF;
					line-height: 40px;
					font-size: 14px;
					cursor: pointer;
				}
			}
			._imgCodeBox ::v-deep .el-form-item__content{
				display: flex !important;
			}
			._imgCodeBox ::v-deep .el-input{
				flex: 1;
			}
			._imgCodeBox ::v-deep .el-input__inner{
				border-radius: 4px 0 0 4px !important;
				border-right: none !important;
			}
			._imgCodeBox ::v-deep ._captchaImg{
				width: 93px;
				height: 40px;
				cursor: pointer;
				flex-shrink: 0;
				img{
					width: 100%;
					height: 100%;
					border-radius: 0 4px 4px 0;
					border: 1px solid #ddd;
					border-left: none;
				}
			}
			._submitBox {
			display: flex;
			justify-content: center;
		}
			._submitBox{
				display: flex;
				justify-content: center;
			}
		._types{
				margin: 0;
				margin-top: -20px;
				
				.el-checkbox__label {
					display: block;
				}
				
				// 未勾选时：普通文字灰色，链接蓝色
				._agreeText {
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					line-height: 1.8;
					
					span {
						display: inline-block;
						margin: 0 2px;
					}
					
					// 普通文字
					span:nth-child(1),
					span:nth-child(3) {
						color: #666;
						cursor: default;
					}
					
					// 协议链接 - 蓝色 + 下划线
					span:nth-child(2),
					span:nth-child(4) {
						color: #1F8EFF !important;
						cursor: pointer;
						text-decoration: underline;
						
						&:hover {
							color: #51B3FF !important;
						}
					}
				}
				
				// 勾选后全部变蓝色
				.el-checkbox.is-checked .el-checkbox__label {
					color: #1F8EFF !important;
					
					span {
						color: #1F8EFF !important;
					}
				}
			}
		}
	}
}
._pwdBox {
	::v-deep .pwd-question {
		cursor: pointer;
		width: auto;
		margin-right: 2px;
	}
}
</style>
<style scoped>
::v-deep ._LoginBox .el-tabs__nav-wrap::after{
	display: none;
}
::v-deep ._LoginBox .el-tabs__nav{
	left: 38%;
}
::v-deep ._elBox .el-input__inner{
	border-radius: 4px 0 0 4px;
}
::v-deep ._codeBox .el-form-item__content{
	display: flex;
}
</style>